import {createPreloadableLazyComponent} from '../../util/lazyImport';
import type {RouteData} from '../types';
import {ARIA_PATHS} from './ariaPaths';

export const ARIA_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'ARIA',
    },
    exact: true,
    isPrivateRoute: true,
    path: ARIA_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../pages/AriaPage')
    ).Component,
  },
];
